var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 3.33333C2.96506 3.33333 2.66659 3.63181 2.66659 4V13.3333C2.66659 13.7015 2.96506 14 3.33325 14H12.6666C13.0348 14 13.3333 13.7015 13.3333 13.3333V4C13.3333 3.63181 13.0348 3.33333 12.6666 3.33333H3.33325ZM1.33325 4C1.33325 2.89543 2.22868 2 3.33325 2H12.6666C13.7712 2 14.6666 2.89543 14.6666 4V13.3333C14.6666 14.4379 13.7712 15.3333 12.6666 15.3333H3.33325C2.22868 15.3333 1.33325 14.4379 1.33325 13.3333V4Z",
    fill: "#5F646F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0.666666C11.0349 0.666666 11.3333 0.965143 11.3333 1.33333V4C11.3333 4.36819 11.0349 4.66667 10.6667 4.66667C10.2985 4.66667 10 4.36819 10 4V1.33333C10 0.965143 10.2985 0.666666 10.6667 0.666666Z",
    fill: "#5F646F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33341 0.666626C5.7016 0.666626 6.00008 0.965103 6.00008 1.33329V3.99996C6.00008 4.36815 5.7016 4.66663 5.33341 4.66663C4.96522 4.66663 4.66675 4.36815 4.66675 3.99996V1.33329C4.66675 0.965103 4.96522 0.666626 5.33341 0.666626Z",
    fill: "#5F646F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 6.66667C1.33325 6.29848 1.63173 6 1.99992 6H13.9999C14.3681 6 14.6666 6.29848 14.6666 6.66667C14.6666 7.03486 14.3681 7.33333 13.9999 7.33333H1.99992C1.63173 7.33333 1.33325 7.03486 1.33325 6.66667Z",
    fill: "#5F646F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCalendar);
export default __webpack_public_path__ + "static/media/new_calendar.8d1a9c86.svg";
export { ForwardRef as ReactComponent };